/* RESPONSIBLE TEAM: team-inbox */
export default function toBackendPermissionKey(frontEndPermissionKey) {
  return frontEndPermissionKey.replace('can_', '');
}
